import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { KarmaRewardModel } from '@smarttask-common/src/lib/models/Karma/KarmaRewardModel';

export enum karmaRewardActionTypes {
    ADD_REWARD = '[KarmaReward] Create KarmaReward',
    UPSERT_REWARD = '[KarmaReward] Upsert KarmaReward',
    ADD_REWARDS = '[KarmaReward] Add karmaReward',
    UPSERT_REWARDS = '[KarmaReward] Upsert karmaReward',
    UPDATE_REWARD = '[KarmaReward] Update KarmaReward',
    UPDATE_REWARDS = '[KarmaReward] Update karmaReward',
    DELETE_REWARD = '[KarmaReward] Delete KarmaReward',
    DELETE_REWARDS = '[KarmaReward] Delete karmaReward',
    DELETE_ALL_REWARDS = '[KarmaReward] Delete All karmaReward',
    DELETE_ALL = '[KarmaReward] Delete All',
}

export class AddOne implements Action {
    readonly type = karmaRewardActionTypes.ADD_REWARD;
    constructor(public reward: KarmaRewardModel) {}
}

export class AddMany implements Action {
    readonly type = karmaRewardActionTypes.ADD_REWARDS;
    constructor(public rewards: Array<KarmaRewardModel>) {}
}

export class UpsertOne implements Action {
    readonly type = karmaRewardActionTypes.UPSERT_REWARD;

    constructor(public reward: KarmaRewardModel) {}
}

export class UpsertMany implements Action {
    readonly type = karmaRewardActionTypes.UPSERT_REWARDS;
    constructor(public rewards: Array<KarmaRewardModel>) {}
}

export class UpdateOne implements Action {
    readonly type = karmaRewardActionTypes.UPDATE_REWARD;
    constructor(public reward: Update<KarmaRewardModel>) {}
}

export class UpdateMany implements Action {
    readonly type = karmaRewardActionTypes.UPDATE_REWARDS;
    constructor(public rewards: Array<Update<KarmaRewardModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = karmaRewardActionTypes.DELETE_REWARD;
    constructor(public id) {}
}

export class DeleteMany implements Action {
    readonly type = karmaRewardActionTypes.DELETE_REWARDS;
    constructor(public ids: Array<any>) {}
}

export class DeleteAll implements Action {
    readonly type = karmaRewardActionTypes.DELETE_ALL_REWARDS;
    constructor(public ids: Array<any>) {}
}

export class DeleteState implements Action {
    readonly type = karmaRewardActionTypes.DELETE_ALL;
    constructor() {}
}

export type karmaRewardActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany;
